/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
//Import PageHeader
import PageHeader from "../../../components/PageHeader";
import Calendar from "../../../components/Calendar/Calendar";
import { getWorkHistoryCommuteCalendarList } from "../../../apis/work-history";
import { dateToFormat, yesterDay } from "../../../utils/date";
import { isEmpty } from "lodash-es";
import { getWorkScheduleEvent } from "../../../utils/work-schedule-calculator";
import Icon from "../../../components/Icon";
import { WORK_SCHEDULE_EVENT } from "../../../constants/WORK_SCHEDULE_EVENT";
import MyWorkTime from "./myWorkTime";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";

const AttendanceWorkingStatusSelf = (props) => {
  const calendarRef = useRef(null);
  const history = useHistory()
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions,
  }));
  const [event, setEvent] = useState([]);
  const [dateParams, setDateParams] = useState({
    startDate: "",
    endDate: "",
  });
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === "COMMUTE_HISTORY")
      setTargetPermission(targetPermission)
      if (isEmpty(permission)) {
        permissionCheck(history, "COMMUTE_HISTORY")
      }
    }
  }, [permissions])

  useEffect(() => {
    getCalendarData();
  }, [dateParams]);

  const getCalendarData = () => {
    if (isEmpty(dateParams.startDate) && isEmpty(dateParams.endDate)) return;

    getWorkHistoryCommuteCalendarList(dateParams)
      .then((res) => {
        setEvent(getWorkScheduleEvent(res.data));
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const onMonthChage = (date) => {
    const startDate = dateToFormat(date.view.currentStart);
    const endDate = dateToFormat(yesterDay(date.view.currentEnd));

    setDateParams({
      startDate,
      endDate,
    });
  };

  const preMonth = () => {
    let calendarApi = calendarRef.current.getApi();
    calendarApi.prev();
  };

  const next = () => {
    let calendarApi = calendarRef.current.getApi();
    calendarApi.next();
  };

  return (
    // !isEmpty(targetPermission) && (
    <div className="WorkingStatus">
      {/* Render PageHeader */}
      <PageHeader title="나의 출퇴근 기록" />
      <MyWorkTime
        calendarDate={dateParams}
        getPreMonth={preMonth}
        getNextMonth={next}
      />
      <div className="working-status-wrap margin-top-32">
        <Calendar
          forwardedRef={calendarRef}
          event={event}
          onMonthChage={onMonthChage}
        />
        <div className="event-list-wrap">
          <ul className="event-list">
            {WORK_SCHEDULE_EVENT.map(
              ({ label, icon, isExpose }, idx) =>
                isExpose && (
                  <li key={idx} className="event">
                    <Icon src={icon} className="event-icon" />
                    <span className="event-label">{label}</span>
                  </li>
                )
            )}
          </ul>
        </div>
      </div>
    </div>
    // )
  );
};

export default AttendanceWorkingStatusSelf;
